import { render, staticRenderFns } from "./referral.vue?vue&type=template&id=299a9b64&scoped=true&"
import script from "./referral.vue?vue&type=script&lang=js&"
export * from "./referral.vue?vue&type=script&lang=js&"
import style0 from "./referral.vue?vue&type=style&index=0&lang=css&"
import style1 from "./referral.vue?vue&type=style&index=1&id=299a9b64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299a9b64",
  null
  
)

export default component.exports